module.exports = __webpack_public_path__ + "img/poste ganadero.72373db9.jpg";